// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"745":"19f5782df289b400","880":"1e9c26bbddaa914e","932":"92ef1c354e44e3e7"}[chunkId] + ".js";
};